import { render } from "./index.vue?vue&type=template&id=5b6cf5f8"
import script from "./collapsible-table.ts?vue&type=script&lang=js"
export * from "./collapsible-table.ts?vue&type=script&lang=js"

import "./collapsible-table.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script